export const styles = {
  imageContainer: {
    position: 'absolute',
    top: 0,
    bottom: 0,
  },
  loadingContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};
